/**
=========================================================
* Argon Dashboard 2 PRO MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-mui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Argon Dashboard 2 PRO MUI components
import ArgonBox from "components/ArgonBox";

function DataTableBodyCell({ noBorder, align, children, customWidth, cellWidth }) {
  return (
    <ArgonBox
      component="td"
      textAlign={align}
      py={1.5}
      px={cellWidth ? 1 : 3}
      sx={({ borders: { borderWidth, borderColor }, typography: { size } }) => ({
        fontSize: size.sm,
        borderBottom: noBorder ? 0 : `${borderWidth[1]} solid ${borderColor}`,
      })}
    >
      <ArgonBox
        display="inline-block"
        width={customWidth ? "100%" : "max-content"}
        color="text"
        sx={{ verticalAlign: "middle" }}
      >
        {children}
      </ArgonBox>
    </ArgonBox>
  );
}

// Setting default values for the props of DataTableBodyCell
DataTableBodyCell.defaultProps = {
  noBorder: false,
  align: "left",
};

// Typechecking props for the DataTableBodyCell
DataTableBodyCell.propTypes = {
  children: PropTypes.node.isRequired,
  noBorder: PropTypes.bool,
  align: PropTypes.oneOf(["left", "right", "center"]),
  customWidth: PropTypes.bool,
  cellWidth: PropTypes.bool,
};

export default DataTableBodyCell;
